








































import Vue from "vue";
import * as moment from "moment";
import $store from "@/store/store";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class Analyses extends Vue {
  public items: any = [];

  public mounted() {
    this.items = [
      {
        order: 1,
        title: this.$t("sessionsDeclarees").toString(),
        icon: "mdi-calculator",
        link: "/analyses/comptageCaisses/sessionsDeclarees",
        noclient: "",
      },
      {
        order: 2,
        title: this.$t("prelevementsDeclares").toString(),
        icon: "mdi-basket-unfill",
        link: "/analyses/comptageCaisses/prelevementsDeclares",
        global: true,
        noclient: "BUFFALO HIPPO LEON",
      },
      {
        order: 3,
        title: this.$t("mouvementsFinancier&mouvement=DEPENSE").toString(),
        icon: "mdi-minus-circle",
        link: "/analyses/comptageCaisses/mouvementsFinancier&mouvement=DEPENSE",
        global: true,
        noclient: "",
      },
      {
        order: 4,
        title: this.$t("mouvementsFinancier&mouvement=RECETTE").toString(),
        icon: "mdi-plus-circle",
        link: "/analyses/comptageCaisses/mouvementsFinancier&mouvement=RECETTE",
        global: true,
        noclient: "",
      },
      {
        order: 5,
        title: this.$t("vidagesCompte").toString(),
        icon: "mdi-google-circles-group",
        link: "/analyses/comptageCaisses/vidagesCompte",
        global: true,
        noclient: "",
      },
      {
        order: 6,
        title: this.$t("ComptageCoffre").toString(),
        icon: "mdi-cash-lock",
        link: "/analyses/comptageCaisses/comptagesCoffre",
        global: true,
        noclient: "BUFFALO BK HIPPO LEON LE DUFF",
      },
      // {order: 7, title: this.$t("Recus").toString() + " " + this.$t("managers").toString(), icon: "mdi-clipboard-edit", link: "/analyses/recuManagers", global: true, noclient: "BK BUFFALO HIPPO"},
      {
        order: 8,
        title: this.$t("ListExport").toString(),
        icon: "mdi-file-export",
        link: "/analyses/listExports",
        global: false,
        noclient: "",
      },
      {
        order: 9,
        title: this.$t("Repartitions").toString(),
        icon: "mdi-incognito",
        link: "/analyses/repartitions",
        global: false,
        noclient: "BUFFALO HIPPO LEON",
      },
      {
        order: 10,
        title: "Coffre",
        icon: "mdi-safe",
        link: "/analyses/coffre",
        global: false,
        noclient: "",
      },
    ];
    this.items = this.items.sort((p1: any, p2: any) => {
      return p1.order - p2.order;
    });
  }
  /**
   * affichage uniquement des entrées disponibles pour le client
   */
  public filteredItem() {
    let itemsToShow = this.items;
    itemsToShow = itemsToShow.filter((item: any) => {
      return !item.noclient.includes(this.client);
    });
    return itemsToShow;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
